// extracted by mini-css-extract-plugin
module.exports = {"colorBox":"styles_colorBox__2xWX-","active":"styles_active__P6knP"};